
import { TranslatedOrTextStyledProperty } from "@/utils/documents/translated-or-text-styled-property";
import Vue from "vue";
import { SaleLayoutCol } from "@/utils/sale-layouts/col";
import { SaleLayoutTableLine } from "@/utils/sale-layouts/table-line";
import { DocumentPageSettings } from "@/utils/documents/page-settings";
import AppDetailsImage from "./DetailsImage.vue";
import { SaleLayoutDetailImage } from "@/utils/sale-layouts/detail-image";

export default Vue.extend({
	props: {
		cols: Array as () => SaleLayoutCol[],
		titleLine: Array as () => SaleLayoutTableLine[],
		dateLine: Array as () => SaleLayoutTableLine[],
		beforeImage: {
			type: Object as ()=>SaleLayoutDetailImage,
			required: true
		},
		afterImage: {
			type: Object as ()=>SaleLayoutDetailImage,
			required: true
		},
		lang: String,
		pageSettings: {
			type: Object as ()=>DocumentPageSettings,
			required: true
		},
	},
	computed: {
		headerCols():SaleLayoutCol[]{
			return this.cols.filter(c=>c.HeaderField != null);
		},
		cssVars(): any {
			return {
				"--bg-color": this.pageSettings.DefaultBackgroundColor,
				"--border-color": this.pageSettings.DefaultBorderColor,
				"--border-width": this.pageSettings.DefaultBorderSize + "px"
			};
		},
		beforeImageWidth():string {
			if (this.beforeImage.Prop == "") {
				return "0";
			}
			return `${this.beforeImage.Width}mm`;
		},
		afterImageWidth():string {
			if (this.afterImage.Prop == "") {
				return "0";
			}
			return `${this.afterImage.Width}mm`;
		}
	},
	methods: {
		getPropValue(prop: TranslatedOrTextStyledProperty): string {
			if (!prop.Prop) return "";
			return this.$t("models.map.Sale." + prop.Prop).toString();
		},
		getStyle(col:SaleLayoutCol):any{
			if (!col.HeaderField) return null;
			let result = col.HeaderField.Style.getStyle();
			result.width = col.getWidth();
			result.left = col.getHeaderPosition(this.cols);
			return result;
		},
		getLeft(list:SaleLayoutTableLine[], col:SaleLayoutTableLine):string{
			let offset = 0.0;
			for (let item of list){
				if (item == col){
					break;
				}
				offset += item.Width;
			}
			offset = col.Position - offset;
			return `${offset}mm`;
		},
	},
	components: {
		AppDetailsImage
	}
});
